<template>
	<template v-if="!data.giftcard_data">
		<div class="wc-payment" :class="[{'wc-disabled': (data.enabled == false || value == true), 'active': (value == data.id && data.enabled != false)}, data.code]">
			<div class="wc-payment-row1">
				<input name="payment" :id="'field-payment-' + data.id" :value="data.id" type="radio" @click="(newPayment != null || additionalPayment != null) ? updateNewPaymentItem() : updatePaymentItem()" v-model="value" />
				<label :for="'field-payment-' + data.id">
					{{ data.title }}
					<template v-if="data.code == 'bankart'">
						<div class="payment-icons">
							<img src="/images/master.svg" alt="">
							<img src="/images/maestro.svg" alt="">
							<img src="/images/visa.svg" alt="">
							<img src="/images/activa.svg" alt="">
						</div>
					</template>
					<template v-if="data.code == 'bankart_diners'">
						<div class="payment-icons">
							<img src="/images/diners.svg" alt="">
						</div>
					</template>
					<template v-if="data.code == 'flik'">
						<div class="payment-icons">
							<img src="/images/flik.png" alt="">
						</div>
					</template>
				</label>
			</div>
			<div v-if="data.description || data.options || data.possible_installments" class="wc-payment-row2" :class="{'active': (value == data.id && data.enabled != false), 'reverse': data.id == 9}">
				<div v-if="data.description && data.code != 'leanpay'" class="wc-payment-description" v-html="paymentDescription"></div>
				<template v-if="data.id == 9 && data.options">
					<div class="wc-payment-leanypay-box">
						<div class="wc-payment-subtitle"><BaseCmsLabel code="leanpay_choose_option" /></div>
						<div class="wc-payment-leanpay" v-for="leanpay in data.options" :key="leanpay.id" :class="{'field-error': leanpay.enabled_when_remove_products != null && leanpay.selected == true, 'active': leanpay.selected == true}">
							<input name="payment" :id="'field-payment-card-' + leanpay.id" :value="leanpay.id + 1000" @change.self="(newPayment != null || additionalPayment != null) ? updateNewPaymentLeanpay() : updatePaymentLeanpay()" type="radio" v-model="leanpayId" />
							<label :for="'field-payment-card-' + leanpay.id" :class="leanpay.payment_title">
								<span class="cnt">
									<span class="title">{{ leanpay.payment_title }}</span>
									<span v-if="leanpay.selected == true && leanpay.id == 39" class="desc">
										<BaseCmsLabel code="leanpay_desc_razrezana_cena" tag="span" />
									</span>
									<span v-if="leanpay.selected == true && leanpay.id == 38" class="desc">
										<BaseCmsLabel code="leanpay_desc_brezobrestno_financiranje" tag="span" />
									</span>
									<span v-if="leanpay.selected == true && leanpay.id == 37" class="desc">
										<BaseCmsLabel code="leanpay_desc_obrestno_financiranje" tag="span" />
									</span>

									<span v-if="leanpay.enabled_when_remove_products != null && leanpay.selected == true" class="wc-payment-leanpay-disabled">
										<BaseCmsLabel code="leanpay_disabled" tag="span" class="wc-payment-leanpay-disabled-desc" />
										<span class="wc-payment-leanpay-disabled-products-row">
											<span class="wc-payment-leanpay-disabled-products">
												<div v-for="leanpayItem in leanpay.remove_products_details" :key="leanpayItem.index" :data="leanpayItem">
													<span class="wc-payment-leanpay-product-img">
														<WebshopLeanpayItemImage v-for="leanpayItem in leanpay.remove_products_details" :key="leanpayItem.index" :data="leanpayItem" />
													</span>
												</div>
											</span>
											<span @click.prevent="leanpayRemoveItems()" class="wc-payment-leanpay-disabled-btn">
												<BaseCmsLabel code="leanpay_btn_remove" tag="span" />
											</span>
										</span>
									</span>
								</span>
							</label>
						</div>
					</div>
				</template>
				<template v-else-if="data.options">
					<BaseCmsLabel code="bankart_choose_card" tag="div" class="wc-payment-subtitle" />
					<div class="wc-payment-cards">
						<div class="wc-payment-card" v-for="card in data.options" :key="card.id" :class="{'active': card.selected == true, 'active-new': newPaymentCard == card.id, 'disabled': card.enabled == false}">
							<input name="payment" :id="'field-payment-card-' + card.id" :value="card.id + 100" @change="(newPayment != null || additionalPayment != null) ? updateNewPaymentCard() : updatePaymentCard()" type="radio" v-model="creditCardId" />
							<label :for="'field-payment-card-' + card.id" :class="card.payment_title">{{ card.payment_title }}</label>
						</div>
					</div>
				</template>
				<template v-if="data.possible_installments">
					<BaseCmsLabel code="diners_possible_installments" tag="div" class="wc-payment-subtitle" />
					<div class="wc-payment-installments-row">
						<select class="wc-payment-installments" name="diners-installments" @change="(newPayment != null || additionalPayment != null) ? updateNewPaymentInstallment() : updatePaymentInstallment()" v-model="cc_installments_options">
							<option v-for="(installment, index) in data.possible_installments" :key="index" :value="installment">
								<template v-if="installment == 1"><BaseCmsLabel code="installments_1" /></template>
								<template v-else>{{ installment }}</template>
							</option>
						</select>
					</div>
				</template>
			</div>
		</div>
	</template>
</template>

<script setup>
	import {useField, defineRule, useValidateForm} from 'vee-validate';
	const validate = useValidateForm();
	const webshop = useWebshop();
	const endpoints = useEndpoints();
	const apiRoutes = useApiRoutes();
	const props = defineProps(['data', 'cart']);
	const { checkoutLoading, orderSubmit, formValid, newPayment, additionalPayment, newPaymentCard, newPaymentId, newPaymentOptions, newPaymentInstallment, shippingLeanpayError  } = useCheckout();
	const {gtmTrack} = useGtmBB();

	//description
	const paymentDescription = computed(() => {
		let desc = (props.data.description) ? props.data.description : null;
		let digitalVoucher = (props.cart.total && props.cart.total.digital_voucher) ? props.cart.total.digital_voucher : null;
		var formatter = new Intl.NumberFormat('sl-SI', {
			style: 'currency',
			currency: 'EUR'
		})
		if(desc && digitalVoucher) {
			let digitalVoucherValue = formatter.format(digitalVoucher);
			desc = desc.replace("%SELECTED_PAYMENT_LIST_TOTAL%", digitalVoucherValue);

		}
		return desc;
	})

	// validation rules
	let validationShema = 'required|';

	// form validation patterns
	defineRule('required', value => {
		if (value) {
			return true;
		}
	});

	// process input
	const { handleChange, value, currentValue } = useField(
		'payment', validationShema,
		{initialValue: ((additionalPayment.value == null && newPayment.value == null &&  props.cart.payments?.selected != null && props.cart.payments.selected[0].enabled == true) ? props.cart.payments.selected[0].id : 0)}
	)

	//credit card
	let creditCardSelected = (additionalPayment.value == null && newPayment.value == null && props.cart != null && props.cart.payments.selected != null) ? props.cart.payments.selected[0].options : 0;
	let cs = '';
	if(creditCardSelected && creditCardSelected != 0) {
		let c = creditCardSelected.find(el => el.selected == true);
		let cs = (c == true) ? c.id : '';
	}
	let creditCardId = ref((cs) ? cs : 0);

	//installment
	let cc_installments_options = ref((additionalPayment.value == null && newPayment.value == null && props.cart != null && props.cart.payments.selected != null) ? props.cart.payments.selected[0].installments : 1);

	//leanpay
	let leanypaySelected = (additionalPayment.value == null && newPayment.value == null && props.cart != null && props.cart.payments.selected != null) ? props.cart.payments.selected[0].options : 0;
	let ls = '';
	if(leanypaySelected && leanypaySelected != 0) {
		let l = leanypaySelected.find(el => el.selected == true);
		let ls = (l == true) ? l.id : '';
	}
	let leanpayId = ref((ls) ? ls : 0);

	//validate payment options
	function validateOptions(data) {
		let selectedPayments = (data.cart != null) ? data.cart.payments.selected : null;
		let selectedOptions = (selectedPayments != null) ? selectedPayments[0].options : null;
		let selectedOption = null;
		let selectedOptionProduct = false;
		if(selectedOptions != null) {
			selectedOption = selectedOptions.find(el => el.selected == true);
			selectedOptionProduct = (selectedOption && selectedOption.enabled_when_remove_products != null) ? true : false;
		}

		formValid.value = (selectedOptions == null || (selectedOption != null && selectedOptionProduct == false)) ? 1 : 0;
	}

	// update payment
	async function updatePaymentItem() {
		checkoutLoading.value = true;
		let paymentOptions = (props.data.options != null) ? props.data.options : 0;
		let paymentOption = 0;
		if(paymentOptions && paymentOptions != 0) {
			paymentOptions.find(el => {
				if(el.selected == true) {
					paymentOption = el.id;
				}
			})
		}
		let cc_installments_options_value = (props.data.possible_installments != null) ? cc_installments_options.value : 1;

		await useApi(`${endpoints.get('_post_hapi_customer')}`, {
			method: 'POST',
			body: {payment: props.data.id, payment_option_id: paymentOption, cc_installments: cc_installments_options_value},
		}).then(async res => {
			await webshop.fetchCart()
			.then(res => {
				validateOptions(res);
			});
		});

		gtmTrack('add_payment_info', {cart: webshop.getCartData(), paymentOption: props.data.code});
		checkoutLoading.value = false;
	}

	let validateTimeout = null;
	async function updateNewPaymentItem() {
		if(validateTimeout) clearTimeout(validateTimeout);
		newPaymentId.value = props.data.id;
		newPaymentOptions.value = (props.data.options != null) ? 1 : null;
		validateTimeout = setTimeout(async () => {
			await validate();
		},200);
		gtmTrack('add_payment_info', {cart: webshop.getCartData(), paymentOption: props.data.code});
	}

	// update payment card
	async function updatePaymentCard() {
		checkoutLoading.value = true;
		let creditCardIdValue = (creditCardId.value > 0) ? creditCardId.value - 100 : 0;
		let cc_installments_options_value = (props.data.possible_installments != null) ? cc_installments_options.value : 1;

		await useApi(`${endpoints.get('_post_hapi_customer')}`, {
			method: 'POST',
			body: {payment: props.data.id, payment_option_id: creditCardIdValue, cc_installments: cc_installments_options_value},
		}).then(async res => {
			await webshop.fetchCart()
			.then(res => {
				validateOptions(res);
			});
		});

		checkoutLoading.value = false;
	}

	async function updateNewPaymentCard() {
		const creditCardIdValueNew = creditCardId.value;
		newPaymentCard.value = creditCardIdValueNew - 100;
	}

	onMounted(() => {
		// validate leanpay payment options
		if(leanypaySelected) {
			const cartData = webshop.getCartData();
			validateOptions(cartData);
		}
	})

	// update payment installment
	async function updatePaymentInstallment() {
		checkoutLoading.value = true;
		let creditCardIdValue = (creditCardId.value > 0) ? creditCardId.value - 100 : 0;
		let cc_installments_options_value = (props.data.possible_installments != null) ? cc_installments_options.value : 1;

		await useApi(`${endpoints.get('_post_hapi_customer')}`, {
			method: 'POST',
			body: {payment: props.data.id, payment_option_id: creditCardIdValue, cc_installments: cc_installments_options_value},
		}).then(async res => {
			await webshop.fetchCart()
			.then(res => {
				validateOptions(res);
			});
		});

		checkoutLoading.value = false;
	}

	async function updateNewPaymentInstallment() {
		newPaymentInstallment.value = cc_installments_options.value;
	}

	// update payment leanpay
	async function updatePaymentLeanpay() {
		checkoutLoading.value = true;
		let leanpayIdValue = (leanpayId.value > 0) ? leanpayId.value - 1000 : 0;
		let cc_installments_options_value = (props.data.possible_installments != null) ? cc_installments_options.value : 1;

		await useApi(`${endpoints.get('_post_hapi_customer')}`, {
			method: 'POST',
			body: {payment: props.data.id, payment_option_id: leanpayIdValue, cc_installments: cc_installments_options_value},
		}).then(async res => {
			await webshop.fetchCart()
			.then(res => {
				validateOptions(res);
			});
		});

		checkoutLoading.value = false;
	}

	async function leanpayRemoveItems() {
		checkoutLoading.value = true;

		let shopping_cart_codes = []
		props.data.options.forEach(el => {
			if(el.selected == true && el.enabled_when_remove_products != null) {
				el.enabled_when_remove_products.forEach(el2 => {
					shopping_cart_codes.push({'shopping_cart_code':el2})
				})
			}
		})
		await useApi(`${endpoints.get('_delete_hapi_webshop_product')}?parcel-default-shipping=1`, {
			method: 'DELETE',
			body: shopping_cart_codes
		}).then(async (res) => {
			if(res.data.label_name == 'success_deleted_product_and_set_parcel_default_shipping') {
				navigateTo(apiRoutes.getAppUrl('webshop_shipping'));
				shippingLeanpayError.value = 1;
			} else {
				await webshop.fetchCart()
				.then(async (res) => {
					if(orderSubmit.value == 0) {
						checkoutLoading.value = false;
					}

					if(res?.data?.cart?.indicators?.is_any_parcel_shipping_empty) {
						navigateTo(apiRoutes.getAppUrl('webshop_shipping'));
						await webshop.setParcelDefaultShipping()
						.then(res => {
							webshop.fetchCart();
						})
					}

					validateOptions(res);
				})
			}

			checkoutLoading.value = false;
		});
	}
</script>

<style lang="less" scoped>
	.wc-payment{
		padding: 12px 15px; border: 1px solid var(--gray2); border-radius: 8px; background: #fff;
		&.active{
			border-color: var(--blueDark);
			.wc-payment-row1>label{
				&:before{background: var(--blueDark); border-color: var(--blueDark); box-shadow: inset 0 0 0 3px var(--white);}
			}
		}
		&.wc-disabled{
			pointer-events: none;
			input[type=radio]+label{color: var(--gray2);}
			input[type=radio]+label:before{border-color: var(--gray2); background: transparent;}
		}
	}
	.wc-payment-description{font-size: 14px; line-height: 1.5; color: var(--gray5); padding: 0 0 15px 0; text-wrap: balance;
		&:last-child{padding: 0;}
	}
	.wc-payment-row2{
		display: none; font-size: 14px; padding-top: 15px;
		&.active{display: block;}
	}
	.wc-payment-subtitle{padding: 0 0 10px;}
	input[type=radio]+label{
		font-size: 14px; font-weight: bold;
		&:before{top: -1px;}
	}
	.wc-payment-cards{display: flex; gap: 10px; flex-direction: column;}
	.wc-payment-card{
		input[type=radio]+label{
			border: 1px solid var(--gray2); border-radius: 8px; font-size: 14px; font-weight: bold; padding: 10px 15px 10px 45px;
			&:before{left: 15px; top: 9px;}
		}
		&.active, &.active-new{
			input[type=radio]+label{
				border-color: var(--blueDark);
				&:before{background: var(--blueDark); border-color: var(--blueDark); box-shadow: inset 0 0 0 3px #fff;}
			}
		}
	}
	.wc-payment-installments{
		width: 280px;
	}
	.payment-icons{
		position: absolute; top: 0; right: 0; display: flex; gap: 8px;
		@media (max-width: @m){display: none;}
		img{height: 20px; width: auto;}
	}

	.wc-payment-leanypay-box{
		display: flex; flex-direction: column; gap: 12px;
		.wc-payment-subtitle{padding: 0;}
	}
	.wc-payment-leanpay{
		input[type=radio]+label{
			border: 1px solid var(--gray2); border-radius: 8px; font-size: 14px; font-weight: bold; padding: 14px 15px 14px 45px;
			&:before{left: 15px; top: 13px;}
		}
		.desc{font-weight: normal; font-size: 14px;
			:deep(p):last-child{padding: 0;}
		}
		&.active{
			input[type=radio]+label{
				border-color: var(--blueDark);
				&:before{background: var(--blueDark); border-color: var(--blueDark); box-shadow: inset 0 0 0 3px #fff;}
			}
		}
	}
	/*
	.wc-payment{
		margin-bottom: -1px; order: 3;
		&.gift-card{
			margin-bottom: 20px; order: 1;
			input[type=checkbox]+label{
				display: flex; align-items: center; width: 100%; padding: 17px 30px 17px 55px; border: 1px solid @borderColor; font-size: 15px; font-weight: 600;
				@media (max-width: @m){padding-left: 50px;}
			}
			input[type=checkbox]+label:before{
				top: 17px; left: 21px; border-color: @inputTextColor;
				@media (max-width: @m){left: 15px;}
			}
			&>input[type=checkbox]:checked + label{
				background: #EBF4FF; border-color: @blue; color: @blue; z-index: 1;
				.desc, .wc-payment-leanpay-disabled-desc{color: @textColor;}
			}
			&.active .wc-payment-row1>label:before{box-shadow: none}
		}
		&.active .wc-payment-row1>label{
			background: #EBF4FF; border-color: @blue!important; color: @blue; z-index: 1;
			&:before{background: @blue; border-color: @blue!important; box-shadow: inset 0 0 0 3px @white;}
		}
		&.wc-disabled{
			pointer-events: none;
			input[type=radio]+label{color: #b2c7dd;}
			input[type=radio]+label:before{border-color: #D7E4EF; background: transparent;}
		}
		input[type=radio]+label{
			display: flex; align-items: center; width: 100%; padding: 17px 30px 17px 55px; border: 1px solid @borderColor; font-size: 15px; font-weight: 600;
			@media (max-width: @m){padding-left: 50px;}
		}
		input[type=radio]+label:before{
			top: 17px; left: 21px; border-color: @inputTextColor;
			@media (max-width: @m){left: 15px;}
		}
		&>input[type=radio]:checked + label{
			background: #EBF4FF; border-color: @blue; color: @blue; z-index: 1;
			.desc, .wc-payment-leanpay-disabled-desc{color: @textColor;}
		}
	}
	.wc-payment-row1{flex-grow: 1;}
	.wc-payment-row2{
		display: none; align-items: center; flex-wrap: wrap; margin-top: -1px; padding: 20px 30px; border: 1px solid @blue; position: relative; z-index: 1;
		@media (max-width: @m){padding: 15px;}
		&.active{display: flex;}
		&.reverse{flex-direction: column-reverse; align-items: flex-start;}
	}
	.wc-payment-description{
		width: 70%; font-size: 14px; line-height: 1.5; color: @inputTextColor;

		@media (max-width: @l){width: 100%;}
	}
	.wc-payment-subtitle{width: 100%; margin-bottom: 10px; font-size: 15px; font-weight: 600;}
	.wc-payment-cards{
		display: flex; align-items: center; width: 100%; margin-bottom: 20px;

		@media (max-width: @m){display: block; margin-bottom: 15px;}
	}
	.wc-payment-card{
		flex-grow: 1; margin-right: 8px;
		&.disabled{pointer-events: none; opacity: 0.5;}
		input[type=radio]+label{
			padding-right: 65px;
			&:after{.pseudo(36px,24px); display: flex; align-items: center; justify-content: center; flex-shrink: 0; right: 15px;}
			&.Mastercard:after{background: url("/images/master.svg") no-repeat; background-size: contain;}
			&.Visa:after{background: url("/images/visa.svg") no-repeat; background-size: contain;}
			&.Maestro:after{background: url("/images/maestro.svg") no-repeat; background-size: contain;}
			&.Activa:after{background: url("/images/activa.svg") no-repeat; background-size: contain;}
		}
		&:last-child{margin-right: 0;}
		&.active, &.active-new{
			&>label{
				background: #EBF4FF; border-color: @blue!important; color: @blue; z-index: 1;
				&:before{background: @blue; border-color: @blue!important; box-shadow: inset 0 0 0 3px @white;}
			}
		}

		@media (max-width: @m){margin: 0 0 -1px;}
	}

	.wc-payment-installments-row{
		display: flex; justify-content: space-between; flex-grow: 1; margin-bottom: 20px;

		@media (max-width: @m){display: block; margin-bottom: 15px;}
	}
	.wc-payment-installments{
		width: 280px; max-width: 280px; flex-shrink: 0; border-bottom: 2px solid @blue; position: relative;
		@media (max-width: @m){width: 100%; max-width: unset;}
	}
	.wc-payment-installments-note{
		display: flex; align-items: center; justify-content: center; flex-grow: 1; margin-left: 20px; padding: 15px 20px; background: #F3F6FA; font-size: 14px; font-weight: 600; text-align: center;
		span:before{.icon-info(); font: 16px/1 @fonti; color: @inputTextColor; margin-right: 10px; position: relative; top: 2px;}
	}

	.wc-payment-leanypay-box{width: 100%; margin-top: 20px;}
	.wc-payment-leanpay{
		width: 100%; margin-bottom: -1px;
		&.active{
			input[type=radio]+label{
				background: #EBF4FF; border-color: @blue!important; color: @blue; z-index: 1;
				&:before{background: @blue; border-color: @blue!important; box-shadow: inset 0 0 0 3px @white;}
			}
		}
		&.field-error{
			input[type=radio]+label{border-color: @red2!important; background: @white; color: @textColor;}
		}
		.cnt{flex-grow: 1;}
		.title{display: block;}
		.desc{
			display: block; width: 70%; margin-top: 5px; font-size: 14px; font-weight: normal; color: @textColor;

			@media (max-width: @l){width: 100%;}
		}

	}
	.wc-payment-leanpay-disabled{display: block; margin: 20px 0 0;}
	.wc-payment-leanpay-disabled-desc{
		display: block; width: 70%; font-size: 15px; color: @textColor; position: relative;
		&:before{.icon-available-last(); font: 18px/1 @fonti; color: @red2; position: absolute; left: -32px;}

		@media (max-width: @l){width: 100%;}
		@media (max-width: @m){font-size: 14px;}
	}
	.wc-payment-leanpay-disabled-products-row{display: flex; align-items: center; margin-top: 15px;}
	.wc-payment-leanpay-disabled-products{display: flex; align-items: center; flex-wrap: wrap; flex-grow: 1; margin-right: 30px;}
	.wc-payment-leanpay-disabled-btn{
		display: flex; align-items: center; flex-shrink: 0; padding-right: 23px; font-size: 14px; font-weight: 600; color: @red2!important; text-decoration: underline; position: relative;
		&:before{.icon-trash(); font: 16px/1 @fonti; font-weight: 600; color: @red2; position: absolute; right: 0;}
		&:hover{text-decoration: none;}
	}
	.wc-payment-leanpay-product-img{
		display: flex; align-items: center; justify-content: center; width: 64px; height: 64px; margin: 0 10px 10px 0;
		img{display: block; width: auto; height: auto; max-width: 100%; max-height: 100%;}

		@media (max-width: @m){width: 54px; height: 54px; margin: 0 5px 10px 0;}
	}
	*/
</style>
